import axios from '@/axios';

const RESOURCE_NAME = '/error-reports';

export default {
    add(startupId = 0, ecosystemId = 0, data) {
        return axios.post(`${RESOURCE_NAME}/add?startup_id=${startupId}&ecosystem_id=${ecosystemId}`, data);
    },
}
